import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import {
  TOUR_AGENT_SHOWING_FAILURE_REASON_OPTION_ITEMS,
  TOUR_SHOWING_FAILURE_REASON_TOUR_GUIDE_PROVIDED,
  TOUR_SHOWING_STATUS_FAILED,
  TOUR_SHOWING_FAILURE_REASON_WANTS_TO_RESCHEDULE,
} from 'common/tourConstants';
import { USER_ROLE_ADMIN, USER_ROLE_AGENT } from 'common/userRoles';
import { SCREEN_ID_AGENT_FAILED_SHOWING } from 'client/constants/screenIds';
import { SR_API_ACTION_ADMIN_MARK_TOUR_NEEDS_RESCHEDULING } from 'api/actionTypes';
import H1 from 'client/components/H1';
import Navbar from 'client/components/Navbar';
import BackButton from 'client/components/BackButton';
import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';
import { getListingUrlPath } from 'common/listingHelpers';

import postWithState from 'client/actions/postWithState';
import AgentActions from 'client/actions/Agent';
import TourActions from 'client/actions/Tour';
import ListingActions from 'client/actions/Listing';
import NavigatorActions from 'client/actions/Navigator';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_AGENT, USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_AGENT_FAILED_SHOWING)
@withScrollToTop
@branch({
  agentUserId: ['currentUser', 'id'],
  listing: ['listing'],
  tours: ['agent', 'tours'],
})
class AgentShowingFailedPage extends Component {
  static fetchData(match, inject) {
    return ListingActions.getById(inject, parseInt(match.params.listingId, 10));
  }

  static propTypes = {
    agentUserId: PropTypes.number.isRequired,
    listing: PropTypes.object,
    tours: PropTypes.array.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  _onSubmitFailedReason = (values) => {
    const { agentUserId, dispatch, match, history, tours } = this.props;

    const listingId = parseInt(match.params.listingId, 10);
    const tourId = parseInt(match.params.agentTourId, 10);
    const currentTour = tours.find((tour) => {
      return tour.id === tourId;
    });
    if (
      values.failureReason === TOUR_SHOWING_FAILURE_REASON_WANTS_TO_RESCHEDULE &&
      currentTour.listings.length === 1
    ) {
      this._markTourNeedsRecheduling(tourId);
    } else {
      dispatch(TourActions.updateShowingStatus, {
        listingId: listingId,
        tourId: tourId,
        showingStatus: TOUR_SHOWING_STATUS_FAILED,
        failureReason: values.failureReason,
        failureReasonAgentProvided: values.reasonProvided,
      })
        .then(() => {
          return dispatch(AgentActions.getAgentTours, {
            agentUserId,
            resetViewingTour: true,
          });
        })
        .then(() => {
          return history.push('/agent/tours');
        });
    }
  };

  _markTourNeedsRecheduling = (tourId) => {
    const { agentUserId, dispatch, history } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_MARK_TOUR_NEEDS_RESCHEDULING,
      payload: {
        tourId: tourId,
      },
    })
      .then(() => {
        return dispatch(AgentActions.getAgentTours, {
          agentUserId,
          resetViewingTour: true,
        });
      })
      .then(() => {
        return history.push('/agent/tours');
      });
  };

  _onBack = () => {
    const { dispatch, listing, match } = this.props;
    const listingUrl = getListingUrlPath(listing, { agentTourId: match.params.agentTourId });
    dispatch(NavigatorActions.replace, { to: listingUrl });
  };

  render() {
    return (
      <div className="page-tours">
        <Navbar leftButton={<BackButton onClick={this._onBack} />} />
        <div className="stepContainer">
          <H1>Why were you not able to open the door?</H1>

          <Formik
            enableReinitialize
            initialValues={{
              failureReason: '',
              reasonProvided: '',
            }}
            onSubmit={this._onSubmitFailedReason}
            render={(formikBag) => {
              const formFields = [
                {
                  id: 'failureReason',
                  type: 'multiple_choice',
                  properties: {
                    choices: TOUR_AGENT_SHOWING_FAILURE_REASON_OPTION_ITEMS.map((reason) => ({
                      value: reason.value,
                      label: reason.label,
                    })),
                    multipleSelection: false,
                    allowEmptyArray: true,
                    onChange: (newValue) => {
                      formikBag.setFieldValue('failureReason', newValue);
                      formikBag.setFieldValue('reasonProvided', '');
                    },
                  },
                },
                {
                  id: 'reasonProvided',
                  type: 'short_text',
                  properties: {
                    className: 'choice',
                    placeholder: 'Other...',
                    onChange: (evt) => {
                      formikBag.setFieldValue(
                        'failureReason',
                        TOUR_SHOWING_FAILURE_REASON_TOUR_GUIDE_PROVIDED,
                      );
                      formikBag.setFieldValue('reasonProvided', evt.target.value);
                    },
                  },
                },
              ];

              return (
                <div>
                  {formFields.map((formField) => (
                    <SrFormikField key={formField.id} formField={formField} formikBag={formikBag} />
                  ))}

                  <ButtonDeprecated onClick={formikBag.handleSubmit} disabled={!formikBag.isValid}>
                    submit failed reason
                  </ButtonDeprecated>
                </div>
              );
            }}
          />
        </div>
      </div>
    );
  }
}

AgentShowingFailedPage.displayName = 'AgentShowingFailedPage';

export default AgentShowingFailedPage;
